import { axiosApiService } from "./axios";

const StudentQuizAPIs = {
  QuizzesGet: async function() {
    try {
      const response = await axiosApiService.get(`training/quiz/quizzes/`);
      return response.data;
    } catch (error) {
      console.error('Error fetching all quizzes:', error.response ? error.response.data : error.message);
      throw error;
    }
  },

  QuizzesForModule: async function(module_id) {
    try {
      const response = await axiosApiService.get(`training/quiz/quizzes/?module_id=${module_id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching quizzes for module:', error.response ? error.response.data : error.message);
      throw error;
    }
  },

  AttemptsRemaining: async function(quiz_id) {
    try {
      const response = await axiosApiService.get(`training/quiz/quizzes/${quiz_id}/attempts-remaining/`);
      return response.data;
    } catch (error) {
      console.error('Error fetching attempts remaining:', error.response ? error.response.data : error.message);
      throw error;
    }
  },

  QuestionsGet: async function(quiz_id) {
    try {
      const response = await axiosApiService.get(`training/quiz/quizzes/${quiz_id}/questions/`);
      return response.data;
    } catch (error) {
      console.error('Error fetching quiz questions:', error.response ? error.response.data : error.message);
      throw error;
    }
  },

  UpdateStatus: async function(quiz_id, status) {
    try {
      const response = await axiosApiService.patch(`training/quiz/quizzes/${quiz_id}/update-status/`, { status });
      return response.data;
    } catch (error) {
      console.error('Error updating quiz status:', error.response ? error.response.data : error.message);
      throw error;
    }
  },

  CalculateScore: async function(quiz_id, answers) {
    try {
      const response = await axiosApiService.post(`training/quiz/quizzes/calculate-score/`, {
        quiz_id,
        answers,
      });
      return response.data;
    } catch (error) {
      console.error('Error calculating score:', error.response ? error.response.data : error.message);
      throw error;
    }
  },

};

export default StudentQuizAPIs;